import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import type { RequestOpts } from '#/api/api-types';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchCompanyInfoQuery } from '#/api/hooks/useCompanyInfo';
import { fetchInterestSheet } from '#/api/hooks/useInterestSheet';
import type { InferLoaderData } from '../types';

export type LoaderData = InferLoaderData<typeof loader>;

export type Params = Record<string, string | undefined>;

export const id = 'calculatorPage' as const;

async function loader({
  params,
  opts,
}: {
  params: Params;
  opts?: RequestOpts;
}) {
  assertParamsPrescence(params);

  const data = await handleSettledPromises([
    fetchInterestSheet(opts),
    fetchCompanyInfoQuery(opts),
  ]);
  assertNoLoaderErrors(id, data);
  const [interestSheet, companyInfo] = data;

  return {
    interestSheet,
    companyInfo,
  };
}

export const useCalculatorPageLoaderData = () =>
  useRouteLoaderData(id) as LoaderData;

export default loader;
